export default __webpack_public_path__ + "ab64b03d65f82ae4053b76bef6d36b30.png";